import React from 'react';

import { FilterOption, DateFilterType, DateFilterError } from './date-filter.types';
import { AVALIABLE_FILTERS } from './filters/avaliable-filters';
import { RadioButton } from '../radio-button/radio-button';

export interface DateFilterMenuContentProps {
  /** Callback to trigger when the start or end date is changed */
  onChange: (filter: Partial<DateFilterType>) => void;
  /** Callback to trigger when the option is changed */
  onOptionChange: (option: FilterOption | undefined) => void;
  /** Any error messages to show the user */
  dateError?: DateFilterError;
  /** The filter to display as the currently selected one */
  dateFilter: DateFilterType;
}

export const DateFilterMenuContent: React.FC<DateFilterMenuContentProps> = ({
  dateError,
  dateFilter,
  onChange,
  onOptionChange,
}) => {
  return (
    <div className="w-88 py-1 pl-2 pr-4.5">
      <div>
        {AVALIABLE_FILTERS.map((filter) => {
          const checked = dateFilter.option === filter.value;
          return (
            <div key={`filter-${filter.value}`}>
              <div key={filter.value} className={'p-2.5'}>
                <RadioButton
                  checked={checked}
                  onChange={() => {
                    onOptionChange(filter.value);
                  }}
                  name={filter.value}
                  value={filter.value}
                  label={filter.value}
                />
              </div>
              {checked && <filter.component onChange={onChange} dateError={dateError} filter={dateFilter} />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DateFilterMenuContent;
